import React from 'react';

function SessionError() {
  return (
    <div className="session-error">
      <div className="session-error-txt">
        It looks like this session has timed out. Please reopen Ask Ralph through the For You tab and start a new chat for more.
      </div>
    </div>
  )
}

export default SessionError
